module.exports = __webpack_public_path__ + "static/media/bottomRightTopLeftLine.29912473.svg";